/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { APIException } from '../model';
// @ts-ignore
import { Booking } from '../model';
// @ts-ignore
import { BookingConfig } from '../model';
// @ts-ignore
import { BookingCreateRequest } from '../model';
// @ts-ignore
import { BookingListing } from '../model';
// @ts-ignore
import { BookingReserveIDRequest } from '../model';
// @ts-ignore
import { BookingReserveIdRead } from '../model';
// @ts-ignore
import { BookingUpdateRequest } from '../model';
// @ts-ignore
import { PaginatedBookingSMSHistoryList } from '../model';
// @ts-ignore
import { PatchedBookingUpdateRequest } from '../model';
// @ts-ignore
import { ValidationError } from '../model';
/**
 * OrganisationBookingApi - axios parameter creator
 * @export
 */
export const OrganisationBookingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This can only occur when:Booking.status `CANCELLED`or Booking.status == `OPEN` AND There\'s no `ACCEPTED` Confirmations.  If there\'s `ACCEPTED` Confirmations, the Booking must be `CANCELLED` first.  See the `status` field on the Booking for more information.
         * @summary Archive the Booking
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingArchiveCreate: async (bookingId: string, buyerOrgId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('orgBookingArchiveCreate', 'bookingId', bookingId)
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingArchiveCreate', 'buyerOrgId', buyerOrgId)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/{booking_id}/archive`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * An SMS is sent out to the recipients of the Confirmation alerting them it has been cancelled.  A cancellation can only occur when Booking.status == `OPEN` and it has at least one `ACCEPTED` Confirmation.  See the `status` field on the Booking for more information.
         * @summary Cancels the Booking and any `ACCEPTED` Confirmations with it
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingCancelCreate: async (bookingId: string, buyerOrgId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('orgBookingCancelCreate', 'bookingId', bookingId)
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingCancelCreate', 'buyerOrgId', buyerOrgId)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/{booking_id}/cancel`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *              Returns the incoming/outgoing counts per Product for the requested date range.              The aggregation matches the Org\'s `setting_stockbook_monthly`: when it is `False` the             counts are grouped by week (keyed by the Sunday that starts each week), and when it is             `True` they are grouped by month (keyed by the first of each month).              `date_from` and `date_to` are optional ISO dates. When omitted they default to the             current period forward. Supplied dates are aligned to the start of their period before             filtering.             
         * @summary Stockbook counts for the Booking config view, weekly or monthly per the Org setting
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {string} [dateFrom] ISO date to count from (optional)
         * @param {string} [dateTo] ISO date to count to (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingConfigCountsRetrieve: async (buyerOrgId: string, aaSource?: string, dateFrom?: string, dateTo?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingConfigCountsRetrieve', 'buyerOrgId', buyerOrgId)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/config/counts`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['date_from'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString().substr(0,10) :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['date_to'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString().substr(0,10) :
                    dateTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Outputs the configuration for the Bookings frontend
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingConfigRetrieve: async (buyerOrgId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingConfigRetrieve', 'buyerOrgId', buyerOrgId)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/config`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Create a Booking
         * @param {string} buyerOrgId 
         * @param {BookingCreateRequest} bookingCreateRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingCreate: async (buyerOrgId: string, bookingCreateRequest: BookingCreateRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingCreate', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'bookingCreateRequest' is not null or undefined
            assertParamExists('orgBookingCreate', 'bookingCreateRequest', bookingCreateRequest)
            const localVarPath = `/v2/org/{buyer_org_id}/booking`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookingCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The filters on this endpoint behave exactly the same as the listing
         * @summary Generates a CSV of all the Bookings which match the filter criteria.
         * @param {string} buyerOrgId 
         * @param {'CT' | 'GT' | 'SH'} product Product id.  * &#x60;CT&#x60; - Cattle * &#x60;SH&#x60; - Sheep * &#x60;GT&#x60; - Goat
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {string} [dateFrom] Date to filter from&lt;br /&gt;Default: start of the current week (Saturday), unless only a date_to is sent through then it defaults to the start that passed in value
         * @param {string} [dateTo] Date to filter to&lt;br /&gt;Default: end of the current week (Saturday), unless only a date_from is sent through then it defaults to the end of that passed in value
         * @param {'bin' | 'json'} [format] 
         * @param {boolean} [includeArchived] Default: 0&lt;br /&gt;When set to 1, the results will include archived Bookings.
         * @param {boolean} [includeEmpty] Default: 0&lt;br /&gt;When set to 1, the results will include days that have no results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingCsvCreate: async (buyerOrgId: string, product: 'CT' | 'GT' | 'SH', aaSource?: string, dateFrom?: string, dateTo?: string, format?: 'bin' | 'json', includeArchived?: boolean, includeEmpty?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingCsvCreate', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'product' is not null or undefined
            assertParamExists('orgBookingCsvCreate', 'product', product)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/csv`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['date_from'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString().substr(0,10) :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['date_to'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString().substr(0,10) :
                    dateTo;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            if (includeArchived !== undefined) {
                localVarQueryParameter['include_archived'] = includeArchived;
            }

            if (includeEmpty !== undefined) {
                localVarQueryParameter['include_empty'] = includeEmpty;
            }

            if (product !== undefined) {
                localVarQueryParameter['product'] = product;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A new Booking is created using the latest historical version of the original Booking including Media. This does not include any Confirmation data or Linked Bookings.
         * @summary Duplicate a booking
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingDuplicateCreate: async (bookingId: string, buyerOrgId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('orgBookingDuplicateCreate', 'bookingId', bookingId)
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingDuplicateCreate', 'buyerOrgId', buyerOrgId)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/{booking_id}/duplicate`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used when initially creating a Booking, this reserves the id in the database for creation which then allows the Org\'s media signature to generate a place to upload any media on creation of the Booking.
         * @summary Reserve a Booking id for creation
         * @param {string} buyerOrgId 
         * @param {BookingReserveIDRequest} bookingReserveIDRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingIdCreate: async (buyerOrgId: string, bookingReserveIDRequest: BookingReserveIDRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingIdCreate', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'bookingReserveIDRequest' is not null or undefined
            assertParamExists('orgBookingIdCreate', 'bookingReserveIDRequest', bookingReserveIDRequest)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/id`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookingReserveIDRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This listing differs from most in that it is a dict instead of a list, where each booking is grouped together by their date.  ``` {     \"results\": {         \"2022-01-02\": {             \"counts\": {\"incoming\": 10, \"outgoing\": 500\"},             \"bookings\": [{booking1}, {booking2}],         },         \"2022-01-01\": {             \"counts\": {\"incoming\": 0, \"outgoing\": 10\"},             \"bookings\": [{booking3}],         }     }     \"report\": {} } ```
         * @summary Retrieve a list of all the Booking associated with the Organisation
         * @param {string} buyerOrgId 
         * @param {'CT' | 'GT' | 'SH'} product Product id.  * &#x60;CT&#x60; - Cattle * &#x60;SH&#x60; - Sheep * &#x60;GT&#x60; - Goat
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {string} [dateFrom] Date to filter from&lt;br /&gt;Default: start of the current week (Saturday), unless only a date_to is sent through then it defaults to the start that passed in value
         * @param {string} [dateTo] Date to filter to&lt;br /&gt;Default: end of the current week (Saturday), unless only a date_from is sent through then it defaults to the end of that passed in value
         * @param {boolean} [includeArchived] Default: 0&lt;br /&gt;When set to 1, the results will include archived Bookings.
         * @param {boolean} [includeEmpty] Default: 0&lt;br /&gt;When set to 1, the results will include days that have no results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingList: async (buyerOrgId: string, product: 'CT' | 'GT' | 'SH', aaSource?: string, dateFrom?: string, dateTo?: string, includeArchived?: boolean, includeEmpty?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingList', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'product' is not null or undefined
            assertParamExists('orgBookingList', 'product', product)
            const localVarPath = `/v2/org/{buyer_org_id}/booking`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['date_from'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString().substr(0,10) :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['date_to'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString().substr(0,10) :
                    dateTo;
            }

            if (includeArchived !== undefined) {
                localVarQueryParameter['include_archived'] = includeArchived;
            }

            if (includeEmpty !== undefined) {
                localVarQueryParameter['include_empty'] = includeEmpty;
            }

            if (product !== undefined) {
                localVarQueryParameter['product'] = product;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Locking can only occur when the status of the Booking == OPEN and the AuthenticatedUser is an admin  See the `status` field on the Booking for more information.
         * @summary Lock the Booking so only Admins can edit it. Admin access only
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingLockCreate: async (bookingId: string, buyerOrgId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('orgBookingLockCreate', 'bookingId', bookingId)
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingLockCreate', 'buyerOrgId', buyerOrgId)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/{booking_id}/lock`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unlocking can only occur when the status of the Booking == `LOCKED` and the Authenticated User is an admin\"  See the `status` field on the Booking for more information.
         * @summary Unlock the Booking. Admin access only
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingLockDestroy: async (bookingId: string, buyerOrgId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('orgBookingLockDestroy', 'bookingId', bookingId)
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingLockDestroy', 'buyerOrgId', buyerOrgId)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/{booking_id}/lock`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the fields passed through and returns the newly updated Booking. See \"update\" for more info
         * @summary Partially update the Booking
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {PatchedBookingUpdateRequest} [patchedBookingUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingPartialUpdate: async (bookingId: string, buyerOrgId: string, aaSource?: string, patchedBookingUpdateRequest?: PatchedBookingUpdateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('orgBookingPartialUpdate', 'bookingId', bookingId)
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingPartialUpdate', 'buyerOrgId', buyerOrgId)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/{booking_id}`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedBookingUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Get the details of a single Booking
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingRetrieve: async (bookingId: string, buyerOrgId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('orgBookingRetrieve', 'bookingId', bookingId)
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingRetrieve', 'buyerOrgId', buyerOrgId)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/{booking_id}`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary List of SMS\'s that have been sent from the Booking
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {string} [contact] 
         * @param {string} [creator] 
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {'CONFIRMATION' | 'REMINDER' | 'UPDATE'} [type] * &#x60;CONFIRMATION&#x60; - Confirmation * &#x60;REMINDER&#x60; - Reminder * &#x60;UPDATE&#x60; - Update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingSmsHistoryList: async (bookingId: string, buyerOrgId: string, aaSource?: string, contact?: string, creator?: string, page?: number, pageSize?: number, type?: 'CONFIRMATION' | 'REMINDER' | 'UPDATE', options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('orgBookingSmsHistoryList', 'bookingId', bookingId)
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingSmsHistoryList', 'buyerOrgId', buyerOrgId)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/{booking_id}/sms/history`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }

            if (contact !== undefined) {
                localVarQueryParameter['contact'] = contact;
            }

            if (creator !== undefined) {
                localVarQueryParameter['creator'] = creator;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the Booking, returning the latest serialized data.  NOTE: the \'row\' still behaves the same as a `PUT` where by any fields not overwritten will still be present. This gives the system the ability to deactivate and re-active fields without losing data.  A Booking can only be edited in the following cases.  1. The Booking.status == `OPEN` 2. The Booking.status == `LOCKED` and Authenticated User is an admin.  If permission is denied the reason will be present in the `detail` key in the body.  See the `status` field on the Booking for more information.  Contacts  The Contacts cannot change value When a Booking - an OPEN/IN_PROGRESS Confirmation - A single accepted recipient - part of a Booking Group 
         * @summary Update the Booking
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {BookingUpdateRequest} bookingUpdateRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingUpdate: async (bookingId: string, buyerOrgId: string, bookingUpdateRequest: BookingUpdateRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('orgBookingUpdate', 'bookingId', bookingId)
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingUpdate', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'bookingUpdateRequest' is not null or undefined
            assertParamExists('orgBookingUpdate', 'bookingUpdateRequest', bookingUpdateRequest)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/{booking_id}`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookingUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganisationBookingApi - functional programming interface
 * @export
 */
export const OrganisationBookingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganisationBookingApiAxiosParamCreator(configuration)
    return {
        /**
         * This can only occur when:Booking.status `CANCELLED`or Booking.status == `OPEN` AND There\'s no `ACCEPTED` Confirmations.  If there\'s `ACCEPTED` Confirmations, the Booking must be `CANCELLED` first.  See the `status` field on the Booking for more information.
         * @summary Archive the Booking
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingArchiveCreate(bookingId: string, buyerOrgId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Booking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingArchiveCreate(bookingId, buyerOrgId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * An SMS is sent out to the recipients of the Confirmation alerting them it has been cancelled.  A cancellation can only occur when Booking.status == `OPEN` and it has at least one `ACCEPTED` Confirmation.  See the `status` field on the Booking for more information.
         * @summary Cancels the Booking and any `ACCEPTED` Confirmations with it
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingCancelCreate(bookingId: string, buyerOrgId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Booking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingCancelCreate(bookingId, buyerOrgId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *              Returns the incoming/outgoing counts per Product for the requested date range.              The aggregation matches the Org\'s `setting_stockbook_monthly`: when it is `False` the             counts are grouped by week (keyed by the Sunday that starts each week), and when it is             `True` they are grouped by month (keyed by the first of each month).              `date_from` and `date_to` are optional ISO dates. When omitted they default to the             current period forward. Supplied dates are aligned to the start of their period before             filtering.             
         * @summary Stockbook counts for the Booking config view, weekly or monthly per the Org setting
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {string} [dateFrom] ISO date to count from (optional)
         * @param {string} [dateTo] ISO date to count to (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingConfigCountsRetrieve(buyerOrgId: string, aaSource?: string, dateFrom?: string, dateTo?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingConfigCountsRetrieve(buyerOrgId, aaSource, dateFrom, dateTo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Outputs the configuration for the Bookings frontend
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingConfigRetrieve(buyerOrgId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingConfigRetrieve(buyerOrgId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Create a Booking
         * @param {string} buyerOrgId 
         * @param {BookingCreateRequest} bookingCreateRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingCreate(buyerOrgId: string, bookingCreateRequest: BookingCreateRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Booking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingCreate(buyerOrgId, bookingCreateRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The filters on this endpoint behave exactly the same as the listing
         * @summary Generates a CSV of all the Bookings which match the filter criteria.
         * @param {string} buyerOrgId 
         * @param {'CT' | 'GT' | 'SH'} product Product id.  * &#x60;CT&#x60; - Cattle * &#x60;SH&#x60; - Sheep * &#x60;GT&#x60; - Goat
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {string} [dateFrom] Date to filter from&lt;br /&gt;Default: start of the current week (Saturday), unless only a date_to is sent through then it defaults to the start that passed in value
         * @param {string} [dateTo] Date to filter to&lt;br /&gt;Default: end of the current week (Saturday), unless only a date_from is sent through then it defaults to the end of that passed in value
         * @param {'bin' | 'json'} [format] 
         * @param {boolean} [includeArchived] Default: 0&lt;br /&gt;When set to 1, the results will include archived Bookings.
         * @param {boolean} [includeEmpty] Default: 0&lt;br /&gt;When set to 1, the results will include days that have no results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingCsvCreate(buyerOrgId: string, product: 'CT' | 'GT' | 'SH', aaSource?: string, dateFrom?: string, dateTo?: string, format?: 'bin' | 'json', includeArchived?: boolean, includeEmpty?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingCsvCreate(buyerOrgId, product, aaSource, dateFrom, dateTo, format, includeArchived, includeEmpty, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * A new Booking is created using the latest historical version of the original Booking including Media. This does not include any Confirmation data or Linked Bookings.
         * @summary Duplicate a booking
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingDuplicateCreate(bookingId: string, buyerOrgId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Booking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingDuplicateCreate(bookingId, buyerOrgId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used when initially creating a Booking, this reserves the id in the database for creation which then allows the Org\'s media signature to generate a place to upload any media on creation of the Booking.
         * @summary Reserve a Booking id for creation
         * @param {string} buyerOrgId 
         * @param {BookingReserveIDRequest} bookingReserveIDRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingIdCreate(buyerOrgId: string, bookingReserveIDRequest: BookingReserveIDRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingReserveIdRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingIdCreate(buyerOrgId, bookingReserveIDRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This listing differs from most in that it is a dict instead of a list, where each booking is grouped together by their date.  ``` {     \"results\": {         \"2022-01-02\": {             \"counts\": {\"incoming\": 10, \"outgoing\": 500\"},             \"bookings\": [{booking1}, {booking2}],         },         \"2022-01-01\": {             \"counts\": {\"incoming\": 0, \"outgoing\": 10\"},             \"bookings\": [{booking3}],         }     }     \"report\": {} } ```
         * @summary Retrieve a list of all the Booking associated with the Organisation
         * @param {string} buyerOrgId 
         * @param {'CT' | 'GT' | 'SH'} product Product id.  * &#x60;CT&#x60; - Cattle * &#x60;SH&#x60; - Sheep * &#x60;GT&#x60; - Goat
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {string} [dateFrom] Date to filter from&lt;br /&gt;Default: start of the current week (Saturday), unless only a date_to is sent through then it defaults to the start that passed in value
         * @param {string} [dateTo] Date to filter to&lt;br /&gt;Default: end of the current week (Saturday), unless only a date_from is sent through then it defaults to the end of that passed in value
         * @param {boolean} [includeArchived] Default: 0&lt;br /&gt;When set to 1, the results will include archived Bookings.
         * @param {boolean} [includeEmpty] Default: 0&lt;br /&gt;When set to 1, the results will include days that have no results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingList(buyerOrgId: string, product: 'CT' | 'GT' | 'SH', aaSource?: string, dateFrom?: string, dateTo?: string, includeArchived?: boolean, includeEmpty?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingListing>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingList(buyerOrgId, product, aaSource, dateFrom, dateTo, includeArchived, includeEmpty, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Locking can only occur when the status of the Booking == OPEN and the AuthenticatedUser is an admin  See the `status` field on the Booking for more information.
         * @summary Lock the Booking so only Admins can edit it. Admin access only
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingLockCreate(bookingId: string, buyerOrgId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Booking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingLockCreate(bookingId, buyerOrgId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Unlocking can only occur when the status of the Booking == `LOCKED` and the Authenticated User is an admin\"  See the `status` field on the Booking for more information.
         * @summary Unlock the Booking. Admin access only
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingLockDestroy(bookingId: string, buyerOrgId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Booking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingLockDestroy(bookingId, buyerOrgId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the fields passed through and returns the newly updated Booking. See \"update\" for more info
         * @summary Partially update the Booking
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {PatchedBookingUpdateRequest} [patchedBookingUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingPartialUpdate(bookingId: string, buyerOrgId: string, aaSource?: string, patchedBookingUpdateRequest?: PatchedBookingUpdateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Booking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingPartialUpdate(bookingId, buyerOrgId, aaSource, patchedBookingUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Get the details of a single Booking
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingRetrieve(bookingId: string, buyerOrgId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Booking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingRetrieve(bookingId, buyerOrgId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary List of SMS\'s that have been sent from the Booking
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {string} [contact] 
         * @param {string} [creator] 
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {'CONFIRMATION' | 'REMINDER' | 'UPDATE'} [type] * &#x60;CONFIRMATION&#x60; - Confirmation * &#x60;REMINDER&#x60; - Reminder * &#x60;UPDATE&#x60; - Update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingSmsHistoryList(bookingId: string, buyerOrgId: string, aaSource?: string, contact?: string, creator?: string, page?: number, pageSize?: number, type?: 'CONFIRMATION' | 'REMINDER' | 'UPDATE', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedBookingSMSHistoryList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingSmsHistoryList(bookingId, buyerOrgId, aaSource, contact, creator, page, pageSize, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the Booking, returning the latest serialized data.  NOTE: the \'row\' still behaves the same as a `PUT` where by any fields not overwritten will still be present. This gives the system the ability to deactivate and re-active fields without losing data.  A Booking can only be edited in the following cases.  1. The Booking.status == `OPEN` 2. The Booking.status == `LOCKED` and Authenticated User is an admin.  If permission is denied the reason will be present in the `detail` key in the body.  See the `status` field on the Booking for more information.  Contacts  The Contacts cannot change value When a Booking - an OPEN/IN_PROGRESS Confirmation - A single accepted recipient - part of a Booking Group 
         * @summary Update the Booking
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {BookingUpdateRequest} bookingUpdateRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingUpdate(bookingId: string, buyerOrgId: string, bookingUpdateRequest: BookingUpdateRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Booking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingUpdate(bookingId, buyerOrgId, bookingUpdateRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganisationBookingApi - factory interface
 * @export
 */
export const OrganisationBookingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganisationBookingApiFp(configuration)
    return {
        /**
         * This can only occur when:Booking.status `CANCELLED`or Booking.status == `OPEN` AND There\'s no `ACCEPTED` Confirmations.  If there\'s `ACCEPTED` Confirmations, the Booking must be `CANCELLED` first.  See the `status` field on the Booking for more information.
         * @summary Archive the Booking
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingArchiveCreate(bookingId: string, buyerOrgId: string, aaSource?: string, options?: any): AxiosPromise<Booking> {
            return localVarFp.orgBookingArchiveCreate(bookingId, buyerOrgId, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * An SMS is sent out to the recipients of the Confirmation alerting them it has been cancelled.  A cancellation can only occur when Booking.status == `OPEN` and it has at least one `ACCEPTED` Confirmation.  See the `status` field on the Booking for more information.
         * @summary Cancels the Booking and any `ACCEPTED` Confirmations with it
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingCancelCreate(bookingId: string, buyerOrgId: string, aaSource?: string, options?: any): AxiosPromise<Booking> {
            return localVarFp.orgBookingCancelCreate(bookingId, buyerOrgId, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         *              Returns the incoming/outgoing counts per Product for the requested date range.              The aggregation matches the Org\'s `setting_stockbook_monthly`: when it is `False` the             counts are grouped by week (keyed by the Sunday that starts each week), and when it is             `True` they are grouped by month (keyed by the first of each month).              `date_from` and `date_to` are optional ISO dates. When omitted they default to the             current period forward. Supplied dates are aligned to the start of their period before             filtering.             
         * @summary Stockbook counts for the Booking config view, weekly or monthly per the Org setting
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {string} [dateFrom] ISO date to count from (optional)
         * @param {string} [dateTo] ISO date to count to (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingConfigCountsRetrieve(buyerOrgId: string, aaSource?: string, dateFrom?: string, dateTo?: string, options?: any): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.orgBookingConfigCountsRetrieve(buyerOrgId, aaSource, dateFrom, dateTo, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Outputs the configuration for the Bookings frontend
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingConfigRetrieve(buyerOrgId: string, aaSource?: string, options?: any): AxiosPromise<BookingConfig> {
            return localVarFp.orgBookingConfigRetrieve(buyerOrgId, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Create a Booking
         * @param {string} buyerOrgId 
         * @param {BookingCreateRequest} bookingCreateRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingCreate(buyerOrgId: string, bookingCreateRequest: BookingCreateRequest, aaSource?: string, options?: any): AxiosPromise<Booking> {
            return localVarFp.orgBookingCreate(buyerOrgId, bookingCreateRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * The filters on this endpoint behave exactly the same as the listing
         * @summary Generates a CSV of all the Bookings which match the filter criteria.
         * @param {string} buyerOrgId 
         * @param {'CT' | 'GT' | 'SH'} product Product id.  * &#x60;CT&#x60; - Cattle * &#x60;SH&#x60; - Sheep * &#x60;GT&#x60; - Goat
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {string} [dateFrom] Date to filter from&lt;br /&gt;Default: start of the current week (Saturday), unless only a date_to is sent through then it defaults to the start that passed in value
         * @param {string} [dateTo] Date to filter to&lt;br /&gt;Default: end of the current week (Saturday), unless only a date_from is sent through then it defaults to the end of that passed in value
         * @param {'bin' | 'json'} [format] 
         * @param {boolean} [includeArchived] Default: 0&lt;br /&gt;When set to 1, the results will include archived Bookings.
         * @param {boolean} [includeEmpty] Default: 0&lt;br /&gt;When set to 1, the results will include days that have no results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingCsvCreate(buyerOrgId: string, product: 'CT' | 'GT' | 'SH', aaSource?: string, dateFrom?: string, dateTo?: string, format?: 'bin' | 'json', includeArchived?: boolean, includeEmpty?: boolean, options?: any): AxiosPromise<any> {
            return localVarFp.orgBookingCsvCreate(buyerOrgId, product, aaSource, dateFrom, dateTo, format, includeArchived, includeEmpty, options).then((request) => request(axios, basePath));
        },
        /**
         * A new Booking is created using the latest historical version of the original Booking including Media. This does not include any Confirmation data or Linked Bookings.
         * @summary Duplicate a booking
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingDuplicateCreate(bookingId: string, buyerOrgId: string, aaSource?: string, options?: any): AxiosPromise<Booking> {
            return localVarFp.orgBookingDuplicateCreate(bookingId, buyerOrgId, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Used when initially creating a Booking, this reserves the id in the database for creation which then allows the Org\'s media signature to generate a place to upload any media on creation of the Booking.
         * @summary Reserve a Booking id for creation
         * @param {string} buyerOrgId 
         * @param {BookingReserveIDRequest} bookingReserveIDRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingIdCreate(buyerOrgId: string, bookingReserveIDRequest: BookingReserveIDRequest, aaSource?: string, options?: any): AxiosPromise<BookingReserveIdRead> {
            return localVarFp.orgBookingIdCreate(buyerOrgId, bookingReserveIDRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * This listing differs from most in that it is a dict instead of a list, where each booking is grouped together by their date.  ``` {     \"results\": {         \"2022-01-02\": {             \"counts\": {\"incoming\": 10, \"outgoing\": 500\"},             \"bookings\": [{booking1}, {booking2}],         },         \"2022-01-01\": {             \"counts\": {\"incoming\": 0, \"outgoing\": 10\"},             \"bookings\": [{booking3}],         }     }     \"report\": {} } ```
         * @summary Retrieve a list of all the Booking associated with the Organisation
         * @param {string} buyerOrgId 
         * @param {'CT' | 'GT' | 'SH'} product Product id.  * &#x60;CT&#x60; - Cattle * &#x60;SH&#x60; - Sheep * &#x60;GT&#x60; - Goat
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {string} [dateFrom] Date to filter from&lt;br /&gt;Default: start of the current week (Saturday), unless only a date_to is sent through then it defaults to the start that passed in value
         * @param {string} [dateTo] Date to filter to&lt;br /&gt;Default: end of the current week (Saturday), unless only a date_from is sent through then it defaults to the end of that passed in value
         * @param {boolean} [includeArchived] Default: 0&lt;br /&gt;When set to 1, the results will include archived Bookings.
         * @param {boolean} [includeEmpty] Default: 0&lt;br /&gt;When set to 1, the results will include days that have no results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingList(buyerOrgId: string, product: 'CT' | 'GT' | 'SH', aaSource?: string, dateFrom?: string, dateTo?: string, includeArchived?: boolean, includeEmpty?: boolean, options?: any): AxiosPromise<BookingListing> {
            return localVarFp.orgBookingList(buyerOrgId, product, aaSource, dateFrom, dateTo, includeArchived, includeEmpty, options).then((request) => request(axios, basePath));
        },
        /**
         * Locking can only occur when the status of the Booking == OPEN and the AuthenticatedUser is an admin  See the `status` field on the Booking for more information.
         * @summary Lock the Booking so only Admins can edit it. Admin access only
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingLockCreate(bookingId: string, buyerOrgId: string, aaSource?: string, options?: any): AxiosPromise<Booking> {
            return localVarFp.orgBookingLockCreate(bookingId, buyerOrgId, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Unlocking can only occur when the status of the Booking == `LOCKED` and the Authenticated User is an admin\"  See the `status` field on the Booking for more information.
         * @summary Unlock the Booking. Admin access only
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingLockDestroy(bookingId: string, buyerOrgId: string, aaSource?: string, options?: any): AxiosPromise<Booking> {
            return localVarFp.orgBookingLockDestroy(bookingId, buyerOrgId, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the fields passed through and returns the newly updated Booking. See \"update\" for more info
         * @summary Partially update the Booking
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {PatchedBookingUpdateRequest} [patchedBookingUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingPartialUpdate(bookingId: string, buyerOrgId: string, aaSource?: string, patchedBookingUpdateRequest?: PatchedBookingUpdateRequest, options?: any): AxiosPromise<Booking> {
            return localVarFp.orgBookingPartialUpdate(bookingId, buyerOrgId, aaSource, patchedBookingUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Get the details of a single Booking
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingRetrieve(bookingId: string, buyerOrgId: string, aaSource?: string, options?: any): AxiosPromise<Booking> {
            return localVarFp.orgBookingRetrieve(bookingId, buyerOrgId, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary List of SMS\'s that have been sent from the Booking
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {string} [contact] 
         * @param {string} [creator] 
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {'CONFIRMATION' | 'REMINDER' | 'UPDATE'} [type] * &#x60;CONFIRMATION&#x60; - Confirmation * &#x60;REMINDER&#x60; - Reminder * &#x60;UPDATE&#x60; - Update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingSmsHistoryList(bookingId: string, buyerOrgId: string, aaSource?: string, contact?: string, creator?: string, page?: number, pageSize?: number, type?: 'CONFIRMATION' | 'REMINDER' | 'UPDATE', options?: any): AxiosPromise<PaginatedBookingSMSHistoryList> {
            return localVarFp.orgBookingSmsHistoryList(bookingId, buyerOrgId, aaSource, contact, creator, page, pageSize, type, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the Booking, returning the latest serialized data.  NOTE: the \'row\' still behaves the same as a `PUT` where by any fields not overwritten will still be present. This gives the system the ability to deactivate and re-active fields without losing data.  A Booking can only be edited in the following cases.  1. The Booking.status == `OPEN` 2. The Booking.status == `LOCKED` and Authenticated User is an admin.  If permission is denied the reason will be present in the `detail` key in the body.  See the `status` field on the Booking for more information.  Contacts  The Contacts cannot change value When a Booking - an OPEN/IN_PROGRESS Confirmation - A single accepted recipient - part of a Booking Group 
         * @summary Update the Booking
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {BookingUpdateRequest} bookingUpdateRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingUpdate(bookingId: string, buyerOrgId: string, bookingUpdateRequest: BookingUpdateRequest, aaSource?: string, options?: any): AxiosPromise<Booking> {
            return localVarFp.orgBookingUpdate(bookingId, buyerOrgId, bookingUpdateRequest, aaSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for orgBookingArchiveCreate operation in OrganisationBookingApi.
 * @export
 * @interface OrganisationBookingApiOrgBookingArchiveCreateRequest
 */
export interface OrganisationBookingApiOrgBookingArchiveCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingArchiveCreate
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingArchiveCreate
     */
    readonly buyerOrgId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingArchiveCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgBookingCancelCreate operation in OrganisationBookingApi.
 * @export
 * @interface OrganisationBookingApiOrgBookingCancelCreateRequest
 */
export interface OrganisationBookingApiOrgBookingCancelCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingCancelCreate
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingCancelCreate
     */
    readonly buyerOrgId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingCancelCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgBookingConfigCountsRetrieve operation in OrganisationBookingApi.
 * @export
 * @interface OrganisationBookingApiOrgBookingConfigCountsRetrieveRequest
 */
export interface OrganisationBookingApiOrgBookingConfigCountsRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingConfigCountsRetrieve
     */
    readonly buyerOrgId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingConfigCountsRetrieve
     */
    readonly aaSource?: string

    /**
     * ISO date to count from (optional)
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingConfigCountsRetrieve
     */
    readonly dateFrom?: string

    /**
     * ISO date to count to (optional)
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingConfigCountsRetrieve
     */
    readonly dateTo?: string
}

/**
 * Request parameters for orgBookingConfigRetrieve operation in OrganisationBookingApi.
 * @export
 * @interface OrganisationBookingApiOrgBookingConfigRetrieveRequest
 */
export interface OrganisationBookingApiOrgBookingConfigRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingConfigRetrieve
     */
    readonly buyerOrgId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingConfigRetrieve
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgBookingCreate operation in OrganisationBookingApi.
 * @export
 * @interface OrganisationBookingApiOrgBookingCreateRequest
 */
export interface OrganisationBookingApiOrgBookingCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingCreate
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {BookingCreateRequest}
     * @memberof OrganisationBookingApiOrgBookingCreate
     */
    readonly bookingCreateRequest: BookingCreateRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgBookingCsvCreate operation in OrganisationBookingApi.
 * @export
 * @interface OrganisationBookingApiOrgBookingCsvCreateRequest
 */
export interface OrganisationBookingApiOrgBookingCsvCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingCsvCreate
     */
    readonly buyerOrgId: string

    /**
     * Product id.  * &#x60;CT&#x60; - Cattle * &#x60;SH&#x60; - Sheep * &#x60;GT&#x60; - Goat
     * @type {'CT' | 'GT' | 'SH'}
     * @memberof OrganisationBookingApiOrgBookingCsvCreate
     */
    readonly product: 'CT' | 'GT' | 'SH'

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingCsvCreate
     */
    readonly aaSource?: string

    /**
     * Date to filter from&lt;br /&gt;Default: start of the current week (Saturday), unless only a date_to is sent through then it defaults to the start that passed in value
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingCsvCreate
     */
    readonly dateFrom?: string

    /**
     * Date to filter to&lt;br /&gt;Default: end of the current week (Saturday), unless only a date_from is sent through then it defaults to the end of that passed in value
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingCsvCreate
     */
    readonly dateTo?: string

    /**
     * 
     * @type {'bin' | 'json'}
     * @memberof OrganisationBookingApiOrgBookingCsvCreate
     */
    readonly format?: 'bin' | 'json'

    /**
     * Default: 0&lt;br /&gt;When set to 1, the results will include archived Bookings.
     * @type {boolean}
     * @memberof OrganisationBookingApiOrgBookingCsvCreate
     */
    readonly includeArchived?: boolean

    /**
     * Default: 0&lt;br /&gt;When set to 1, the results will include days that have no results
     * @type {boolean}
     * @memberof OrganisationBookingApiOrgBookingCsvCreate
     */
    readonly includeEmpty?: boolean
}

/**
 * Request parameters for orgBookingDuplicateCreate operation in OrganisationBookingApi.
 * @export
 * @interface OrganisationBookingApiOrgBookingDuplicateCreateRequest
 */
export interface OrganisationBookingApiOrgBookingDuplicateCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingDuplicateCreate
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingDuplicateCreate
     */
    readonly buyerOrgId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingDuplicateCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgBookingIdCreate operation in OrganisationBookingApi.
 * @export
 * @interface OrganisationBookingApiOrgBookingIdCreateRequest
 */
export interface OrganisationBookingApiOrgBookingIdCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingIdCreate
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {BookingReserveIDRequest}
     * @memberof OrganisationBookingApiOrgBookingIdCreate
     */
    readonly bookingReserveIDRequest: BookingReserveIDRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingIdCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgBookingList operation in OrganisationBookingApi.
 * @export
 * @interface OrganisationBookingApiOrgBookingListRequest
 */
export interface OrganisationBookingApiOrgBookingListRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingList
     */
    readonly buyerOrgId: string

    /**
     * Product id.  * &#x60;CT&#x60; - Cattle * &#x60;SH&#x60; - Sheep * &#x60;GT&#x60; - Goat
     * @type {'CT' | 'GT' | 'SH'}
     * @memberof OrganisationBookingApiOrgBookingList
     */
    readonly product: 'CT' | 'GT' | 'SH'

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingList
     */
    readonly aaSource?: string

    /**
     * Date to filter from&lt;br /&gt;Default: start of the current week (Saturday), unless only a date_to is sent through then it defaults to the start that passed in value
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingList
     */
    readonly dateFrom?: string

    /**
     * Date to filter to&lt;br /&gt;Default: end of the current week (Saturday), unless only a date_from is sent through then it defaults to the end of that passed in value
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingList
     */
    readonly dateTo?: string

    /**
     * Default: 0&lt;br /&gt;When set to 1, the results will include archived Bookings.
     * @type {boolean}
     * @memberof OrganisationBookingApiOrgBookingList
     */
    readonly includeArchived?: boolean

    /**
     * Default: 0&lt;br /&gt;When set to 1, the results will include days that have no results
     * @type {boolean}
     * @memberof OrganisationBookingApiOrgBookingList
     */
    readonly includeEmpty?: boolean
}

/**
 * Request parameters for orgBookingLockCreate operation in OrganisationBookingApi.
 * @export
 * @interface OrganisationBookingApiOrgBookingLockCreateRequest
 */
export interface OrganisationBookingApiOrgBookingLockCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingLockCreate
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingLockCreate
     */
    readonly buyerOrgId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingLockCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgBookingLockDestroy operation in OrganisationBookingApi.
 * @export
 * @interface OrganisationBookingApiOrgBookingLockDestroyRequest
 */
export interface OrganisationBookingApiOrgBookingLockDestroyRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingLockDestroy
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingLockDestroy
     */
    readonly buyerOrgId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingLockDestroy
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgBookingPartialUpdate operation in OrganisationBookingApi.
 * @export
 * @interface OrganisationBookingApiOrgBookingPartialUpdateRequest
 */
export interface OrganisationBookingApiOrgBookingPartialUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingPartialUpdate
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingPartialUpdate
     */
    readonly buyerOrgId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingPartialUpdate
     */
    readonly aaSource?: string

    /**
     * 
     * @type {PatchedBookingUpdateRequest}
     * @memberof OrganisationBookingApiOrgBookingPartialUpdate
     */
    readonly patchedBookingUpdateRequest?: PatchedBookingUpdateRequest
}

/**
 * Request parameters for orgBookingRetrieve operation in OrganisationBookingApi.
 * @export
 * @interface OrganisationBookingApiOrgBookingRetrieveRequest
 */
export interface OrganisationBookingApiOrgBookingRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingRetrieve
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingRetrieve
     */
    readonly buyerOrgId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingRetrieve
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgBookingSmsHistoryList operation in OrganisationBookingApi.
 * @export
 * @interface OrganisationBookingApiOrgBookingSmsHistoryListRequest
 */
export interface OrganisationBookingApiOrgBookingSmsHistoryListRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingSmsHistoryList
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingSmsHistoryList
     */
    readonly buyerOrgId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingSmsHistoryList
     */
    readonly aaSource?: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingSmsHistoryList
     */
    readonly contact?: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingSmsHistoryList
     */
    readonly creator?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof OrganisationBookingApiOrgBookingSmsHistoryList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof OrganisationBookingApiOrgBookingSmsHistoryList
     */
    readonly pageSize?: number

    /**
     * * &#x60;CONFIRMATION&#x60; - Confirmation * &#x60;REMINDER&#x60; - Reminder * &#x60;UPDATE&#x60; - Update
     * @type {'CONFIRMATION' | 'REMINDER' | 'UPDATE'}
     * @memberof OrganisationBookingApiOrgBookingSmsHistoryList
     */
    readonly type?: 'CONFIRMATION' | 'REMINDER' | 'UPDATE'
}

/**
 * Request parameters for orgBookingUpdate operation in OrganisationBookingApi.
 * @export
 * @interface OrganisationBookingApiOrgBookingUpdateRequest
 */
export interface OrganisationBookingApiOrgBookingUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingUpdate
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingUpdate
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {BookingUpdateRequest}
     * @memberof OrganisationBookingApiOrgBookingUpdate
     */
    readonly bookingUpdateRequest: BookingUpdateRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationBookingApiOrgBookingUpdate
     */
    readonly aaSource?: string
}

/**
 * OrganisationBookingApi - object-oriented interface
 * @export
 * @class OrganisationBookingApi
 * @extends {BaseAPI}
 */
export class OrganisationBookingApi extends BaseAPI {
    /**
     * This can only occur when:Booking.status `CANCELLED`or Booking.status == `OPEN` AND There\'s no `ACCEPTED` Confirmations.  If there\'s `ACCEPTED` Confirmations, the Booking must be `CANCELLED` first.  See the `status` field on the Booking for more information.
     * @summary Archive the Booking
     * @param {OrganisationBookingApiOrgBookingArchiveCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingApi
     */
    public orgBookingArchiveCreate(requestParameters: OrganisationBookingApiOrgBookingArchiveCreateRequest, options?: any) {
        return OrganisationBookingApiFp(this.configuration).orgBookingArchiveCreate(requestParameters.bookingId, requestParameters.buyerOrgId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * An SMS is sent out to the recipients of the Confirmation alerting them it has been cancelled.  A cancellation can only occur when Booking.status == `OPEN` and it has at least one `ACCEPTED` Confirmation.  See the `status` field on the Booking for more information.
     * @summary Cancels the Booking and any `ACCEPTED` Confirmations with it
     * @param {OrganisationBookingApiOrgBookingCancelCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingApi
     */
    public orgBookingCancelCreate(requestParameters: OrganisationBookingApiOrgBookingCancelCreateRequest, options?: any) {
        return OrganisationBookingApiFp(this.configuration).orgBookingCancelCreate(requestParameters.bookingId, requestParameters.buyerOrgId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *              Returns the incoming/outgoing counts per Product for the requested date range.              The aggregation matches the Org\'s `setting_stockbook_monthly`: when it is `False` the             counts are grouped by week (keyed by the Sunday that starts each week), and when it is             `True` they are grouped by month (keyed by the first of each month).              `date_from` and `date_to` are optional ISO dates. When omitted they default to the             current period forward. Supplied dates are aligned to the start of their period before             filtering.             
     * @summary Stockbook counts for the Booking config view, weekly or monthly per the Org setting
     * @param {OrganisationBookingApiOrgBookingConfigCountsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingApi
     */
    public orgBookingConfigCountsRetrieve(requestParameters: OrganisationBookingApiOrgBookingConfigCountsRetrieveRequest, options?: any) {
        return OrganisationBookingApiFp(this.configuration).orgBookingConfigCountsRetrieve(requestParameters.buyerOrgId, requestParameters.aaSource, requestParameters.dateFrom, requestParameters.dateTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary Outputs the configuration for the Bookings frontend
     * @param {OrganisationBookingApiOrgBookingConfigRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingApi
     */
    public orgBookingConfigRetrieve(requestParameters: OrganisationBookingApiOrgBookingConfigRetrieveRequest, options?: any) {
        return OrganisationBookingApiFp(this.configuration).orgBookingConfigRetrieve(requestParameters.buyerOrgId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary Create a Booking
     * @param {OrganisationBookingApiOrgBookingCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingApi
     */
    public orgBookingCreate(requestParameters: OrganisationBookingApiOrgBookingCreateRequest, options?: any) {
        return OrganisationBookingApiFp(this.configuration).orgBookingCreate(requestParameters.buyerOrgId, requestParameters.bookingCreateRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The filters on this endpoint behave exactly the same as the listing
     * @summary Generates a CSV of all the Bookings which match the filter criteria.
     * @param {OrganisationBookingApiOrgBookingCsvCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingApi
     */
    public orgBookingCsvCreate(requestParameters: OrganisationBookingApiOrgBookingCsvCreateRequest, options?: any) {
        return OrganisationBookingApiFp(this.configuration).orgBookingCsvCreate(requestParameters.buyerOrgId, requestParameters.product, requestParameters.aaSource, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.format, requestParameters.includeArchived, requestParameters.includeEmpty, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A new Booking is created using the latest historical version of the original Booking including Media. This does not include any Confirmation data or Linked Bookings.
     * @summary Duplicate a booking
     * @param {OrganisationBookingApiOrgBookingDuplicateCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingApi
     */
    public orgBookingDuplicateCreate(requestParameters: OrganisationBookingApiOrgBookingDuplicateCreateRequest, options?: any) {
        return OrganisationBookingApiFp(this.configuration).orgBookingDuplicateCreate(requestParameters.bookingId, requestParameters.buyerOrgId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used when initially creating a Booking, this reserves the id in the database for creation which then allows the Org\'s media signature to generate a place to upload any media on creation of the Booking.
     * @summary Reserve a Booking id for creation
     * @param {OrganisationBookingApiOrgBookingIdCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingApi
     */
    public orgBookingIdCreate(requestParameters: OrganisationBookingApiOrgBookingIdCreateRequest, options?: any) {
        return OrganisationBookingApiFp(this.configuration).orgBookingIdCreate(requestParameters.buyerOrgId, requestParameters.bookingReserveIDRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This listing differs from most in that it is a dict instead of a list, where each booking is grouped together by their date.  ``` {     \"results\": {         \"2022-01-02\": {             \"counts\": {\"incoming\": 10, \"outgoing\": 500\"},             \"bookings\": [{booking1}, {booking2}],         },         \"2022-01-01\": {             \"counts\": {\"incoming\": 0, \"outgoing\": 10\"},             \"bookings\": [{booking3}],         }     }     \"report\": {} } ```
     * @summary Retrieve a list of all the Booking associated with the Organisation
     * @param {OrganisationBookingApiOrgBookingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingApi
     */
    public orgBookingList(requestParameters: OrganisationBookingApiOrgBookingListRequest, options?: any) {
        return OrganisationBookingApiFp(this.configuration).orgBookingList(requestParameters.buyerOrgId, requestParameters.product, requestParameters.aaSource, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.includeArchived, requestParameters.includeEmpty, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Locking can only occur when the status of the Booking == OPEN and the AuthenticatedUser is an admin  See the `status` field on the Booking for more information.
     * @summary Lock the Booking so only Admins can edit it. Admin access only
     * @param {OrganisationBookingApiOrgBookingLockCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingApi
     */
    public orgBookingLockCreate(requestParameters: OrganisationBookingApiOrgBookingLockCreateRequest, options?: any) {
        return OrganisationBookingApiFp(this.configuration).orgBookingLockCreate(requestParameters.bookingId, requestParameters.buyerOrgId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unlocking can only occur when the status of the Booking == `LOCKED` and the Authenticated User is an admin\"  See the `status` field on the Booking for more information.
     * @summary Unlock the Booking. Admin access only
     * @param {OrganisationBookingApiOrgBookingLockDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingApi
     */
    public orgBookingLockDestroy(requestParameters: OrganisationBookingApiOrgBookingLockDestroyRequest, options?: any) {
        return OrganisationBookingApiFp(this.configuration).orgBookingLockDestroy(requestParameters.bookingId, requestParameters.buyerOrgId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the fields passed through and returns the newly updated Booking. See \"update\" for more info
     * @summary Partially update the Booking
     * @param {OrganisationBookingApiOrgBookingPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingApi
     */
    public orgBookingPartialUpdate(requestParameters: OrganisationBookingApiOrgBookingPartialUpdateRequest, options?: any) {
        return OrganisationBookingApiFp(this.configuration).orgBookingPartialUpdate(requestParameters.bookingId, requestParameters.buyerOrgId, requestParameters.aaSource, requestParameters.patchedBookingUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary Get the details of a single Booking
     * @param {OrganisationBookingApiOrgBookingRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingApi
     */
    public orgBookingRetrieve(requestParameters: OrganisationBookingApiOrgBookingRetrieveRequest, options?: any) {
        return OrganisationBookingApiFp(this.configuration).orgBookingRetrieve(requestParameters.bookingId, requestParameters.buyerOrgId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary List of SMS\'s that have been sent from the Booking
     * @param {OrganisationBookingApiOrgBookingSmsHistoryListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingApi
     */
    public orgBookingSmsHistoryList(requestParameters: OrganisationBookingApiOrgBookingSmsHistoryListRequest, options?: any) {
        return OrganisationBookingApiFp(this.configuration).orgBookingSmsHistoryList(requestParameters.bookingId, requestParameters.buyerOrgId, requestParameters.aaSource, requestParameters.contact, requestParameters.creator, requestParameters.page, requestParameters.pageSize, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the Booking, returning the latest serialized data.  NOTE: the \'row\' still behaves the same as a `PUT` where by any fields not overwritten will still be present. This gives the system the ability to deactivate and re-active fields without losing data.  A Booking can only be edited in the following cases.  1. The Booking.status == `OPEN` 2. The Booking.status == `LOCKED` and Authenticated User is an admin.  If permission is denied the reason will be present in the `detail` key in the body.  See the `status` field on the Booking for more information.  Contacts  The Contacts cannot change value When a Booking - an OPEN/IN_PROGRESS Confirmation - A single accepted recipient - part of a Booking Group 
     * @summary Update the Booking
     * @param {OrganisationBookingApiOrgBookingUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingApi
     */
    public orgBookingUpdate(requestParameters: OrganisationBookingApiOrgBookingUpdateRequest, options?: any) {
        return OrganisationBookingApiFp(this.configuration).orgBookingUpdate(requestParameters.bookingId, requestParameters.buyerOrgId, requestParameters.bookingUpdateRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }
}
